/**
 * Pull JSON out of one or more
 * <script type="application/ld+json">…</script> blocks.
 */
const extractJsonLdFromScripts = (str) => {
  const ldJsonRegex =
    /<script\b[^>]*\btype\s*=\s*["']application\/ld\+json["'][^>]*>([\s\S]*?)<\/script>/gi;

  const matches = [];
  let match;

  while ((match = ldJsonRegex.exec(str)) !== null) {
    const content = match?.[1]?.trim();
    if (content) {
      matches.push(content);
    }
  }

  if (matches.length > 0) {
    return matches;
  }

  if (str.startsWith("<script")) {
    const scriptMatch = str.match(/<script\b[^>]*>([\s\S]*?)<\/script>/i);
    if (scriptMatch) {
      const inner = scriptMatch[1].trim();
      if (
        (inner.startsWith("{") && inner.endsWith("}")) ||
        (inner.startsWith("[") && inner.endsWith("]"))
      ) {
        return [inner];
      }
    }
  }

  return null;
};

const parseJsonString = (jsonString) => {
  if (!jsonString || typeof jsonString !== "string") {
    return {};
  }

  let content = jsonString.trim();
  const extractedScripts = extractJsonLdFromScripts(content);

  if (extractedScripts !== null) {
    if (extractedScripts.length === 1) {
      content = extractedScripts[0];
    } else {
      try {
        return extractedScripts.map((item) => JSON.parse(item.replace(/\\n/g, "")));
      } catch (error) {
        console.error("Error parsing JSON-LD scripts:", error);
        return {};
      }
    }
  }

  // Other raw HTML (not JSON-LD script): don't try JSON.parse
  if (content.startsWith("<") && !content.startsWith("{") && !content.startsWith("[")) {
    return {};
  }

  try {
    return JSON.parse(content.replace(/\\n/g, ""));
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return {};
  }
};

export default parseJsonString;
